import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Platform } from '@ionic/angular';
import { StorageService } from '../services/storage/storage.service';
import { SplashScreen } from '@capacitor/splash-screen';
import { STORAGE_CONST } from '../constants/storage-constants';
import { Capacitor } from '@capacitor/core';
import { AppHelperService } from '../services/app-helper/app-helper.service';
@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private storage: StorageService,
    private helperSvc: AppHelperService,
    private plt: Platform,
    private router: Router
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const isReady = await this.plt.ready();
    if (isReady) {
      if (Capacitor.isNativePlatform()) {
          this.getAccountInfo();
      }
      const firstRunIsDone = await this.storage.get(STORAGE_CONST.FIRST_RUN_PERMISSION);
      if (firstRunIsDone) {
        const params = route.queryParams;
        this.router.navigate(['/app/add-files'], {
          replaceUrl: true,
          queryParams: params?.domainname && params?.locationid ? params : {},
        });
        return true;
      }
      return true;
    }
    return false;
  }

  /**
   * Get account details
   */
  async getAccountInfo() {
    try {
      setTimeout(() => {
        SplashScreen.hide();
      }, 100);
      await this.helperSvc.handleStatusBar();
    } catch (error) {
      console.log('Error in getting account info: ', error);
    }
  }
}
